import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhcn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import '@/style/reset.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import QrCode from 'qrcode.vue'
import vueEsign from 'vue-esign'
const app = createApp(App)
app.component('qr-code', QrCode)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(store).use(vueEsign).use(router).use(ElementPlus, {
  locale: zhcn
}).mount('#app')
